import React, { useContext, useState, FormEvent, ChangeEvent } from 'react';
import { Container, Row, Col, Image } from "react-bootstrap";
import { Navigate } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

import { Paths } from'../pages';
import { UserContext } from '../hooks/useUser';

function LoginPage(): JSX.Element {
    const { authToken, loginUser } = useContext(UserContext);
    const [username, setUserName] = useState<string>('');
    const [password, setPassword] = useState<string>('');

    const navigate = useNavigate();

    const handleSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
        console.log("loggin in from loginpage");
        e.preventDefault();

        if (loginUser) {
            loginUser(username, password);
        }
    };

    const goToCreate = () => {
        navigate("/create");
    };

    if (authToken) {
        return <Navigate to={Paths.root} replace={true} />;
    }

    return (
        <Container fluid data-bs-theme="dark" data-theme="dark" className="text-light" id="body">
            <div className="Auth-form-container">
                <form className="Auth-form" onSubmit={handleSubmit}>
                    <div className="Auth-form-content">
                        <Row className="justify-content-center">
                            <Col>
                                <div className="d-flex justify-content-center">
                                    <Image src={process.env.PUBLIC_URL + '/sc_logo.jpg'} style={{height: 169}} />
                                </div>
                            </Col>
                        </Row>
                        <Row className="justify-content-center" >
                            <Col className="justify-content-center" xs={12} style={{width: 300}}>
                                <div className="form-group">
                                    <label>Email</label>
                                    <input
                                    type="text"
                                    className="form-control mt-1"
                                    placeholder="Enter email"
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setUserName(e.target.value)}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row className="justify-content-center" >
                            <Col className="justify-content-center" xs={12} style={{width: 300}}>
                                <div className="form-group mt-3">
                                    <label>Password</label>
                                    <input
                                    type="password"
                                    className="form-control mt-1"
                                    placeholder="Enter password"
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row className="justify-content-center">
                            <Col className="justify-content-center" xs={12} style={{width: 300}}>
                                <div className="d-grid gap-2 mt-3">
                                    <button type="submit" className="btn btn-primary">
                                    Login
                                    </button>
                                </div>
                            </Col>
                        </Row>
                        <Row className="justify-content-center">
                            <Col className="justify-content-center" xs={12} style={{width: 300}}>
                                <div className="d-grid gap-2 mt-3">
                                    <button onClick={goToCreate} className="btn btn-info">
                                    Create Account
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </form>
            </div>
        </Container>
    );
}

export { LoginPage };
